import { useForm } from "react-hook-form";
import {
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { CustomTextField } from "@shared/components/CustomTextField";
import { emailSchema } from "@shared/utils/yupSchema";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import { resetPassword } from "@store/slices/authSlice";

interface MyForm {
  email: string;
}

const ForgotPasswordForm = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state) => state.auth.isLoading);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<MyForm>({
    resolver: yupResolver(emailSchema),
  });

  const submitForm = (data: MyForm) => {
    if (isLoading) return;
    dispatch(resetPassword(data.email));
  };

  return (
    <Stack
      component="form"
      onSubmit={handleSubmit(submitForm)}
      noValidate
      spacing={2}
      sx={{ pt: 1 }}
    >
      <Typography variant="body2" color="text.secondary">
        Enter the email address on your account and we'll send you a link to
        reset your password.
      </Typography>
      <CustomTextField
        {...register("email")}
        autoFocus
        autoComplete="email"
        name="email"
        label="Email"
        type="email"
        disabled={isLoading}
        error={!!errors.email}
        helperText={errors.email?.message ?? " "}
        fullWidth
      />
      <Button
        type="submit"
        variant="contained"
        fullWidth
        size="large"
        disabled={isLoading}
        startIcon={
          isLoading ? <CircularProgress size={18} color="inherit" /> : null
        }
      >
        {isLoading ? "Sending…" : "Send reset link"}
      </Button>
    </Stack>
  );
};

export default ForgotPasswordForm;
